// Card descriptions and per-level recommendation map for the Balanced
// Equation add-level modal. Decision-type keys mirror the canonical
// values in `decisionTypes['Balanced Equation']` from ./data. The
// 'all-types' key is intentionally excluded — it is hidden from the
// new BE flow.
//
// Description segments use { text, bold } so a single bold span can
// be highlighted within an otherwise regular paragraph (matches the
// Figma typography exactly).

export const beDecisionTypeCards = [
  {
    key: 'increase-decrease',
    title: 'Increase or Decrease',
    description: [
      { text: 'In this level, students will decide which BS element ' },
      { text: 'should be increased or decreased', bold: true },
      { text: '.' },
    ],
  },
  {
    key: 'debit-credit2',
    title: 'Debit and Credit',
    description: [
      { text: 'This level layers the decisions. Students have to decide which BS element to increase or decrease, and ' },
      { text: 'whether to debit or credit', bold: true },
      { text: '.' },
    ],
  },
  {
    key: 'accounts-impacted',
    title: 'Accounts Impacted',
    description: [
      { text: 'This level layers the decisions. Students have to decide ' },
      { text: 'which accounts are impacted', bold: true },
      { text: ', their associated element, and whether to increase or decrease.' },
    ],
  },
  {
    key: 'income-statement-impact',
    title: 'Income Statement Impact',
    description: [
      { text: 'In this level, students analyze ' },
      { text: 'income and expense related transactions', bold: true },
      { text: ' and decide how each affects the BS element.' },
    ],
  },
];

// Decision type recommended for each scenarioLevelNumber. Used to render
// the "Recommended for this Level" badge on the matching card. Only
// Level 1 surfaces a recommendation; Level 2/3 leave the choice to the
// instructor.
export const beRecommendedByLevel = {
  1: 'increase-decrease',
};

export const beModalCopy = {
  title: (levelNumber) => `Level ${levelNumber} | Select Decision Type`,
  subtitle: 'In each level, students review a series of transactions and decide how the transactions impact the Accounting Equation.',
  step2Title: (levelNumber) => `Level ${levelNumber} | Select Scenario & Transactions`,
  step2Subtitle: 'Select a scenario and related transactions',
  scenariosColumnHeader: 'Business Scenarios',
  transactionsColumnHeader: 'Transactions',
  changeDecisionTypeButton: 'Change Decision Type',
  saveButton: 'Save',
  recommendedBadge: ['Recommended', 'for this Level'],
  switchScenarioWarningTitle: 'Are you sure?',
  switchScenarioWarningText: 'Selecting a transaction from a different business scenario will override your existing selections. You cannot mix transactions from different business scenarios in one level.',
};
